<div class="dialog-header">
  <div class="header-title">
    <h2 mat-dialog-title>Предпросмотр распределения</h2>
    @if (data.stage) {
      <mat-chip class="stage-chip">{{ getStageTitle(data.stage) }}</mat-chip>
    }
  </div>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (!data.data) {
    <div class="no-data">
      <mat-icon>info</mat-icon>
      <p>Нет данных для отображения</p>
    </div>
  } @else {
    <div class="quota-info">
      <h3>{{ data.quotaName }}</h3>
    </div>

    <!-- Summary Information -->
    <div class="summary-grid">
      <div class="summary-item">
        <span class="label">Общий объем квоты (тонн)</span>
        <span class="value">{{ data.data.totalQuotaVolume | kgToTons }}</span>
      </div>
      <div class="summary-item">
        <span class="label">Объем для распределения на этом этапе (тонн)</span>
        <span class="value">{{ data.data.stageVolume | kgToTons }}</span>
      </div>
      <div class="summary-item">
        <span class="label">Процент от общей квоты (%)</span>
        <span class="value">{{ data.data.stagePercentage }}%</span>
      </div>
      <div class="summary-item">
        <span class="label">Количество участников:</span>
        <span class="value">{{ data.data.participantCount }}</span>
      </div>
      <div class="summary-item">
        <span class="label">Общий объем к распределению (тонн)</span>
        <span class="value">{{ data.data.totalToDistribute | kgToTons }}</span>
      </div>
      <div class="summary-item">
        <span class="label">Остаток после распределения (тонн)</span>
        <span class="value">{{ data.data.remainingAfterDistribution | kgToTons }}</span>
      </div>
    </div>

    <!-- Stage Description -->
    @if (data.data.stageDescription) {
      <div class="stage-description">
        <span class="desc-label">Описание этапа:</span>
        <span class="desc-value">{{ data.data.stageDescription }}</span>
      </div>
    }

    <!-- Stage Visual Icons -->
    @if (data.stage === 'STAGE_1') {
      <div class="stage-visual">
        <img src="/assets/icons/first.svg" alt="Этап 1" width="200" height="80">
      </div>
    }

    @if (data.stage === 'STAGE_2') {
      <div class="stage-visual">
        <img src="/assets/icons/second.svg" alt="Этап 2" width="200" height="80">
      </div>
    }

    <!-- Formula -->
    @if (data.data.formula && (data.stage === 'STAGE_3' || data.stage === 'STAGE_FOR_NEW_SUPPLIERS')) {
      <div class="formula-container">
        <p class="formula-text">{{ data.data.formula }}</p>
      </div>
    }

    <!-- Blocking Reasons -->
    @if (data.data.blockingReasons && data.data.blockingReasons.length > 0) {
      <div class="alert alert-error">
        <div class="alert-header">
          <mat-icon>error</mat-icon>
          <span>Блокирующие причины</span>
        </div>
        <ul>
          @for (reason of data.data.blockingReasons; track reason) {
            <li>{{ reason }}</li>
          }
        </ul>
      </div>
    }

    <!-- Warnings -->
    @if (data.data.warnings && data.data.warnings.length > 0) {
      <div class="alert alert-warning">
        <div class="alert-header">
          <mat-icon>warning</mat-icon>
          <span>Предупреждения</span>
        </div>
        <ul>
          @for (warning of data.data.warnings; track warning) {
            <li>{{ warning }}</li>
          }
        </ul>
      </div>
    }

    <!-- Results Table -->
    <div class="table-container">
      <table mat-table [dataSource]="data.data.previewResults" class="preview-table">
        <!-- Supplier Name Column -->
        <ng-container matColumnDef="supplierName">
          <th mat-header-cell *matHeaderCellDef>ФИО поставщика</th>
          <td mat-cell *matCellDef="let row">{{ row.supplierName || '—' }}</td>
        </ng-container>

        <!-- Allocated Volume Column -->
        <ng-container matColumnDef="allocatedVolume">
          <th mat-header-cell *matHeaderCellDef>Распределенный объем (тонн)</th>
          <td mat-cell *matCellDef="let row">{{ row.allocatedVolume | kgToTons }}</td>
        </ng-container>

        <!-- Individual Historical Volume Column -->
        <ng-container matColumnDef="individualHistoricalVolume">
          <th mat-header-cell *matHeaderCellDef>Объем поставщика (тонн) (V1+V1-9 или V)</th>
          <td mat-cell *matCellDef="let row">{{ row.individualHistoricalVolume | kgToTons }}</td>
        </ng-container>

        <!-- Stage Quota Volume Column -->
        <ng-container matColumnDef="stageQuotaVolume">
          <th mat-header-cell *matHeaderCellDef>Общий объем квоты (тонн)</th>
          <td mat-cell *matCellDef="let row">{{ row.stageQuotaVolume | kgToTons }}</td>
        </ng-container>

        <!-- Allocation Percentage Column -->
        <ng-container matColumnDef="allocationPercentage">
          <th mat-header-cell *matHeaderCellDef>Процент от общего объема (%)</th>
          <td mat-cell *matCellDef="let row">{{ row.allocationPercentage || '—' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- No data row -->
        <tr class="mat-row no-data-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            Нет данных для отображения
          </td>
        </tr>
      </table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Закрыть</button>
</mat-dialog-actions>
